import { Box, Skeleton, Stack } from '@mui/material'
import type { FC } from 'react'

import { CardEmbedment, CardPrimaryLoading, CardVariant, CarouselLoading, COLORS, unit } from '@hcr/ui'

import { Background, LayoutNavigation } from '../../../common'

export const OwnerUncontractedLoading: FC = () => {
  return (
    <LayoutNavigation>
      <Box paddingX={unit(3)} bgcolor={COLORS.white}>
        <Background url=''>
          <Stack marginTop={unit(64)} padding={unit(5)} bgcolor={COLORS.ruoho['20%']}>
            <Box marginBottom={unit(4)}>
              <Skeleton width='80%' height={unit(10.5)} variant='rectangular' />
            </Box>
            <Box marginBottom={unit(7)}>
              <Skeleton width='95%' height={unit(6)} />
              <Skeleton width='85%' height={unit(6)} />
              <Skeleton width='90%' height={unit(6)} />
              <Skeleton width='95%' height={unit(6)} />
              <Skeleton width='85%' height={unit(6)} />
            </Box>
          </Stack>
        </Background>
        <Stack gap={unit(3)} paddingY={unit(3)}>
          <CardPrimaryLoading embedment={CardEmbedment.Standalone} variant={CardVariant.Owner} />
          <CarouselLoading slidesMargin={unit(3)} />
          <CardPrimaryLoading embedment={CardEmbedment.Standalone} variant={CardVariant.Owner} />
        </Stack>
      </Box>
    </LayoutNavigation>
  )
}
